import { useTranslation } from 'react-i18next';
import RevealWrapper from './RevealWrapper';

const techStack = [
  { name: 'C#', icon: 'ri-code-s-slash-line' },
  { name: '.NET MAUI', icon: 'ri-layout-line' },
  { name: 'SQLite', icon: 'ri-database-2-line' },
  { name: 'MVVM', icon: 'ri-stack-line' },
  { name: 'XAML', icon: 'ri-file-code-line' },
  { name: 'GitHub Actions', icon: 'ri-git-branch-line' },
];

const PRINCIPLES = [
  { code: '01', titleKey: 'stack.p1.title', bodyKey: 'stack.p1.body', tagKey: 'stack.p1.tag' },
  { code: '02', titleKey: 'stack.p2.title', bodyKey: 'stack.p2.body', tagKey: 'stack.p2.tag' },
  { code: '03', titleKey: 'stack.p3.title', bodyKey: 'stack.p3.body', tagKey: 'stack.p3.tag' },
  { code: '04', titleKey: 'stack.p4.title', bodyKey: 'stack.p4.body', tagKey: 'stack.p4.tag' },
];

export default function StackSection() {
  const { t } = useTranslation();

  return (
    <section id="stack" className="bg-[#111111] border-t border-white/5">
      <div className="px-6 lg:px-14 py-10 border-b border-white/5 flex items-center justify-between">
        <span className="font-mono text-xs text-neutral-600 tracking-widest uppercase">{t('stack.label')}</span>
      </div>

      <div className="px-6 lg:px-14 py-20 lg:py-32">
        <div className="grid md:grid-cols-2 gap-px bg-white/5 mb-px">
          {PRINCIPLES.map((p, idx) => (
            <RevealWrapper key={p.code} delay={idx * 100}>
              <div className="bg-[#111111] p-10 lg:p-14 group hover:bg-[#161616] transition-colors duration-300 h-full">
                <div className="flex items-start justify-between mb-8">
                  <span className="font-black text-4xl text-white/5 group-hover:text-white/10 transition-colors duration-300 leading-none">{p.code}</span>
                  <span className="font-mono text-xs text-neutral-700 border-white/5 border px-2.5 py-1 tracking-widest">{t(p.tagKey)}</span>
                </div>
                <h3 className="text-xl font-black text-white mb-4 tracking-tight">{t(p.titleKey)}</h3>
                <p className="text-neutral-500 text-sm leading-loose">{t(p.bodyKey)}</p>
              </div>
            </RevealWrapper>
          ))}
        </div>

        <RevealWrapper delay={400}>
          <div className="bg-[#0c0c0c] border-white/5 border p-10 lg:p-14">
            <p className="font-mono text-xs text-neutral-600 tracking-widest uppercase mb-10">{t('stack.techLabel')}</p>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5">
              {techStack.map((tech, idx) => (
                <RevealWrapper key={tech.name} delay={500 + idx * 50} direction="up">
                  <div className="flex flex-col items-center gap-4 p-6 border-white/5 border hover:border-white/15 hover:bg-white/[0.02] transition-all duration-300 group">
                    <div className="w-10 h-10 flex items-center justify-center">
                      <i className={`${tech.icon} text-2xl text-neutral-600 group-hover:text-white transition-colors duration-300`} />
                    </div>
                    <span className="font-mono text-xs text-neutral-600 group-hover:text-neutral-400 transition-colors duration-300 text-center">{tech.name}</span>
                  </div>
                </RevealWrapper>
              ))}
            </div>
          </div>
        </RevealWrapper>
      </div>
    </section>
  );
}
